module.exports = __webpack_public_path__ + "img/hongkong.993aa008.jpg";